module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('div', {
    key: "tipo-empresa",
    staticClass: "tipo-empresa-container"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Seleccione el tipo de bien contratado")]), _c('div', {
    staticClass: "select-box"
  }, _vm._l((_vm.tipos), function(o) {
    return _c('div', {
      staticClass: "option bd-color-empresa",
      class: {
        'bg-empresa': _vm.bien.tipo === o.tipo
      },
      on: {
        "click": function($event) {
          _vm.seleccionarTipo(o)
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: o.clase
    }), _c('span', [_vm._v(_vm._s(o.descripcion))])])
  })), _c('div', [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Monto reclamado")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bien.monto),
      expression: "bien.monto"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.bien.monto)
    },
    on: {
      "blur": function($event) {
        _vm.sendData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bien, "monto", $event.target.value)
      }
    }
  }), _vm._l((_vm.monedas), function(o) {
    return _c('div', {
      staticClass: "little-option bd-color-empresa",
      class: {
        'bg-empresa': _vm.bien.moneda === o.codigo
      },
      on: {
        "click": function($event) {
          _vm.seleccionarMoneda(o)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(o.descripcion))])])
  })], 2)]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Descripción")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bien.descripcion),
      expression: "bien.descripcion"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.bien.descripcion)
    },
    on: {
      "blur": _vm.sendData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bien, "descripcion", $event.target.value)
      }
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("3. Identificación de bien contratado")]), _c('p', [_c('span', [_vm._v("Por favor ingrese los datos del producto o servicio que contrató con nosotros")])]), _c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-014db368","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Box-3-identificacion-bien-contratado.vue
// module id = 76
// module chunks = 0